import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrl: './search.component.scss',
    standalone: false
})

export class SearchComponent {
    constructor(private elementRef: ElementRef) {}

    onScrollToTop() {
        // Scroll tothe top of the component smoothly        
        this.elementRef.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
